<template>
  <div
    class="dropdown-box"
    @mouseover="showDropDown=true"
    @mouseleave="showDropDown=false"
  >
    <a class="dropdown-button">
      <div
        class="dropdown-button-text"
        v-text="text"
        :class="{'dropdown-item-selected': itemSelected}"
      ></div>
      <img class="caret" src="https://cdngarenanow-a.akamaihd.net/webmain/static/game_service/bind/icon_arrow.png" />
    </a>
    <div class="dropdown-content" v-show="showDropDown">
      <a
        class="dropdown-item"
        :class="[{'selected-item': selectedIndex===index}]"
        :key="item.name"
        v-for="(item, index) in items"
        v-text="item.name"
        @click.prevent="itemClicked(index)"
      ></a>
    </div>
  </div>
</template>

<script>
import { EVENT } from '@/constants/event'

export default {
  name: 'GSDropDown',
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      defatult: []
    }
  },
  data () {
    return {
      showDropDown: false,
      itemSelected: false,
      selectedIndex: -1
    }
  },
  created () {
    if (this.items.length > 0) {
      this.itemClicked(0)
    }
  },
  computed: {
    text () {
      return (!this.itemSelected && this.placeholder) ||
        this.items[this.selectedIndex].name
    }
  },
  methods: {
    itemClicked (index) {
      this.$emit(EVENT.CHANGED, this.items[index].value)
      this.selectedIndex = index
      this.showDropDown = false
      this.itemSelected = true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/vars/base';

.dropdown-box {
  position: relative;
  width: 100%;

  .dropdown-button {
    position: relative;
    font-size: $base-size * 30;
    color: #88A7BA;
    padding: $base-size * 26 $base-size * 30;
    display: block;
    height: $base-size * 90;
    background: #12232D;
    border: 1px solid #435B69;
    border-radius: $base-size * 6;
    text-decoration: none;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    .dropdown-button-text {
      margin-right: $base-size * 36;
    }
  }

  .caret {
    position: absolute;
    width: $base-size * 18;
    top: 1.2em;
    right: 1em;
    font-size: 1em;
  }

  .dropdown-content {
    position: absolute;
    width: 100%;
    background: #12232D;
    border: 1px solid #435B69;
    border-radius: $base-size * 6;
    min-width: $base-size * 160;
    overflow: auto;
    box-shadow: 0px 0.5rem 1rem 0px rgba(0,0,0,0.2);
    z-index: 1;
  }

  .dropdown-item {
    color: #88A7BA;
    text-decoration: none;
    display: block;
    font-size: $font-size-s;
    letter-spacing: 0;
    padding: $base-size * 25 $base-size * 30;
  }

  .selected-item {
    color: #31BEFF;
    background: #243743;
  }

  .dropdown-item-selected {
    color: #31BEFF;
  }

  .dropdown-item:not(:last-child) {
    border-bottom: 1px solid #455D6B;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GSDropDown.vue